<template>
  <a
    href="#"
    class="btn-back"
    :class="{ '--dark': color === 'dark', '--white': color === 'white' }"
    @click.prevent="$emit('click')"
  >
    <span class="btn-back__stroke"></span>
    <span class="btn-back__label">{{ label }}</span>
  </a>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "dark"
    },
    label: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-back {
  font-family: "Gilam SemiBold";
  // @include fontSizes(15px, 12px, 13px, 15px, 15px);
  font-size: 15px;
  color: $black;
  text-transform: uppercase;
  position: relative;
  padding-left: 40px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  z-index: 1;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    height: 100%;
    width: 55px;
    background-color: $very-light-gray;
    z-index: -1;
    transition: width 0.3s ease, background-color 0.3s ease;
  }
  &:hover {
    &::after {
      width: 75px;
      background-color: $yellow;
    }
  }

  &.--white {
    &::after {
      background-color: $white-20;
    }
    .btn-back__label {
      color: $white;
      pointer-events: none;
    }

    &:hover {
      &::after {
        width: 75px;
        background-color: $yellow;
      }
    }
  }
}

// @media screen and (min-width: $screen-sm) {
//   .btn-back {
//     height: 28px;
//   }
// }

// @media screen and (min-width: $screen-md) {
//   .btn-back {
//     height: 28px;
//   }
// }

// @media screen and (min-width: $screen-lg) {
//   .btn-back {
//     height: 34px;
//   }
// }
</style>
